export enum EntityType {
  PARTNERSHIP = 'partnership',
  LIMITED_LIABILITY_COMPANY = 'limited_liability_company',
  CORPORATION = 'corporation',
  S_CORP = 's_corp',
  TRUST_ESTATE = 'trust_estate'
}
